import _ from 'lodash';

export const baseTableColumn = (name, valueKey, defaultValue) => ({
  name,
  row: (obj) => _.get(obj, valueKey) ?? defaultValue,
});
